var basSlugForAuthors = "experten";
var basSlugForMagazines = "magazine-ebooks";
var basSlugForArtikelSerien = "artikelserien";


export default {

    sandsConstructRealUrl: function(concordObject) {
    if (concordObject) {
        var relUrl = '#';

        if (concordObject && concordObject.__typename) {
            var typeNameOfConcordObject = concordObject.__typename;
            // console.log('typeNameOfConcordObject: ' + typeNameOfConcordObject);
            
            if (typeNameOfConcordObject == 'Brand') {
              if (concordObject.slug && concordObject.slug.length) {
                return '/' + basSlugForMagazines + '/' + concordObject.slug;
              }
            }
            if (typeNameOfConcordObject == 'Issue') {
              if (concordObject.slug && concordObject.slug.length) {
                if (concordObject.brand && concordObject.brand.slug && concordObject.brand.slug.length) {
                  return '/' + basSlugForMagazines + '/' + concordObject.brand.slug + '/' + concordObject.slug;
                }
              }
            }
            if (typeNameOfConcordObject == 'Conference') {
              if (concordObject.slug && concordObject.slug.length) {
                  return '/live-events/' + concordObject.marketingUrl;
              }
            }
            if (typeNameOfConcordObject == 'RecommendedEvent') {
              if (concordObject.slug && concordObject.slug.length) {
                  return '/live-events/' + concordObject.marketingUrl;
              }
            }
            if (typeNameOfConcordObject == 'Course') {
              if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'CONFERENCE') {
                return '/conferences/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'EA') {
                return '/trainings-seminars/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'TUTORIAL') {
                return '/tutorials' + concordObject.marketingUrl;
              }else if (concordObject.slug && concordObject.slug.length && concordObject.genre && concordObject.genre === 'CAMP') {
                return '/conferences/' + concordObject.slug;
              }else if (concordObject.slug && concordObject.slug.length  && concordObject.genre && concordObject.genre === 'FSLE'){
                return '/live-events' + concordObject.marketingUrl;
              }
              else if(concordObject.slug && concordObject.slug.length){
                return '/conferences/' + concordObject.slug;
              }
            }
            if (typeNameOfConcordObject == 'Author') {
                if (concordObject.slug && concordObject.slug.length) {
                    return "/" + basSlugForAuthors + '/' + concordObject.slug;
                }
            }
            if (typeNameOfConcordObject == 'Article') {
              if (concordObject.slug && concordObject.slug.length ) {
                // TODO:
                // check if we have archetypeArticle (clone) article
                // if yes use the archetypeArticle slug and archetypeArticle primary category 
                if (concordObject.archetypeArticle && concordObject.archetypeArticle.primaryCategory && 
                  concordObject.archetypeArticle.slug && concordObject.archetypeArticle.slug.length &&
                  concordObject.archetypeArticle.primaryCategory.slug && concordObject.archetypeArticle.primaryCategory.slug.length ) {
                  return '/' + concordObject.archetypeArticle.primaryCategory.slug + '/' + concordObject.archetypeArticle.slug;
                }
                // if no use normal slug and primary category
                else if (concordObject.primaryCategory && concordObject.primaryCategory.slug && concordObject.primaryCategory.slug.length ) {
                  return '/' + concordObject.primaryCategory.slug + '/' + concordObject.slug;
                }
              }
            }

            if (typeNameOfConcordObject == 'ArticleSeriesItem') {
              //console.log(concordObject);
              //console.log(concordObject.type);
              if (concordObject.type) {
                if (concordObject.slug && concordObject.slug.length) {
                  if (concordObject.type == 'COLUMN') {
                      if (concordObject.authors && concordObject.authors.length) {
                        if (concordObject.authors[0].slug && concordObject.authors[0].slug.length) {
                          return "/" + basSlugForAuthors + '/' + concordObject.authors[0].slug + '/' + concordObject.slug;
                        }
                      }
                  } else  if (concordObject.type == 'SERIES') {
                    //console.log(concordObject);
                    if (concordObject.articles && concordObject.articles.length) {
                      //console.log(2);
                      if (concordObject.articles[0].primaryCategory && concordObject.articles[0].primaryCategory.slug && concordObject.articles[0].primaryCategory.slug.length) {
                        return '/' + concordObject.articles[0].primaryCategory.slug + '/' + basSlugForArtikelSerien + '/' + concordObject.slug;
                      }
                    }
                  }
                }
              }
            }
        }
    }
    return relUrl;
    },

    hexToRgb(hex) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
      });
  
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },

    // generateUrlForPocs(singlePoc) {
    //   // if (singlePoc && singlePoc.schemaType && singlePoc.schemaType == 'ARTICLE' && singlePoc.designation && singlePoc.brandName) {
    //   //   return `/reader/reading/${singlePoc.brandName.split(" ").join("-").toLowerCase()}/${singlePoc.designation}/${singlePoc._id}`;
    //   // } 
    //   // else if(singlePoc && singlePoc.schemaType && singlePoc.schemaType != 'ARTICLE' && singlePoc.slug && singlePoc.parentSlug) {
    //   //   return `/reader/player/${singlePoc.parentSlug}/${singlePoc.slug}`;
    //   // }
    //   if (singlePoc && singlePoc.schemaType && singlePoc.schemaType == 'ARTICLE') {
    //     return `/${singlePoc.categories[0].name.toLowerCase()}/${singlePoc.slug}`;
    //   }
    //   else if(singlePoc && singlePoc.schemaType && singlePoc.parentSlug && singlePoc.schemaType == 'LESSON' && singlePoc.parentGenre && singlePoc.parentGenre == 'CAMP') {
    //     return `/conferences/${singlePoc.parentSlug}`;
    //   }
    //   return null;
    // },

    generateUrlForPocs(singlePoc,app) {
      var baseSlug;
      if(app && app === 'entwickler'){
        baseSlug = 'https://entwickler.de';
      }else{
        baseSlug = 'https://devm.io';
      }
      if (singlePoc && singlePoc.schemaType && singlePoc.schemaType === 'ARTICLE') {
        return `${baseSlug}/${singlePoc.categories[0].name.toLowerCase()}/${singlePoc.slug}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        (singlePoc.parentGenre === 'CAMP' || singlePoc.parentGenre === 'RHEINGOLD' || singlePoc.parentGenre === 'FLEX')
      ) {
        return `${baseSlug}/conferences/${singlePoc.parentSlug}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'TUTORIAL'
      ) {
        return `${baseSlug}/tutorials${singlePoc.marketingUrl}`;
      }
      else if (
        singlePoc &&
        singlePoc.marketingUrl &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'FSLE'
      ) {
        return `${baseSlug}/live-events${singlePoc.marketingUrl}`;
      }
      else if (
        singlePoc &&
        singlePoc.schemaType &&
        singlePoc.parentSlug &&
        singlePoc.schemaType === 'LESSON' &&
        singlePoc.parentGenre &&
        singlePoc.parentGenre === 'EA'
      ) {
        return `${baseSlug}/trainings-seminars${singlePoc.parentSlug}`;
      }
      else if((singlePoc.parentSlug || singlePoc.marketingUrl) && singlePoc.parentGenre && singlePoc.parentGenre == "COURSE"){
        if (singlePoc.marketingUrl) {
            return singlePoc.marketingUrl;
        }
        if (this.showItemBaseOfLangDe && singlePoc.parentSlug) {
            return `https://entwickler.de/kurse/${singlePoc.parentSlug}`;
        }
      }
      return null;
    },

    getCorrectPocType(parentGenre, parentSchemaType,pocSchemaType) {
      if (parentGenre === 'TUTORIAL') {
        return "Tutorial";
      }else if (parentGenre === 'FSLE') {
        return "Live Event";
      }else if (parentGenre === 'COURSE') {
        if (pocSchemaType === 'LESSON') {
          return "Lesson";
        }
      }
      else if (parentGenre === 'RHEINGOLD' || parentGenre === 'CAMP') {
        if (parentSchemaType === 'COURSE') {
          return "Lesson";
        }
      }
      else if (pocSchemaType) {
        return pocSchemaType.toString();
      }
      return "";
    }

}